import { Component, OnInit, Inject, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { EventInfo } from '../model/event.model';
import { EventDocumentInfo } from '../model/eventdocument.model';
import { ProjectDocumentInfo } from '../model/projectdocument.model';
import { IssueInfo } from '../model/issue.model';
import { IssueManagementComponent, summaryInfo, summarydetailInfo } from '../issue-management/issue-management.component'; //Add from lesson learned tab
import { GanttChartControlComponent } from "../gantt-chart-control/gantt-chart-control.component";
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { BaselineInfo } from '../model/baseline.model';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js'; //Add from lesson learned tab
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts'; //Add from lesson learned tab

import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

import {
  HttpEventType,
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { StateInfo } from '../model/StateInfo.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { EmpInfo } from '../model/emp.model';

let today = new Date().toISOString()

@Component({
  selector: 'app-assign-membersupport',
  templateUrl: './assign-membersupport.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./assign-membersupport.component.css']
})
export class AssignMembersupportComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;
  @ViewChild('fileUploader') fileUploader: ElementRef;

  // Add from lesson learned tab
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };

  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];

  // End Add from lesson learned tab

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectPromise: Promise<ProjectInfo[]>
  ProjectList: ProjectInfo[]
  ProjectStatusList: LookupInfo[]

  // flag display for Manager Only and not State Completed or terminate
  IsShowForThisManager: boolean;

  _ParamProjectCode: string
  _ParamProjectName: string
  _ParamCompanyName: string
  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  titlemodal: string
  detailmodal: string

  txtProjectCode: string
  txtProjectName: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlProjectStatusSavedraft: string

  hidProjectId: number
  public currentPageNumber: number = 1
  public totalPages: number
  ProjectTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  txtProjectComment: string;

  // variable  Project Document Zone
  ProjectDocumentPromise: Promise<ProjectDocumentInfo[]>
  ProjectDocumentList: ProjectDocumentInfo[]
  ddlSupportContractType: string = null;
  ddlWarrantyType: string = null;
  ddlMAType: string = null;
  txtWarrantyStartDate: string = null;
  txtWarrantyEndDate: string = null;
  txtMAStartDate: string = null;
  txtMAEndDate: string = null;
  ddlPackage: number = null;

  SupportContractTypeList: any;
  WarrantyTypeList: any;
  MATypeList: any;
  ProjectPackageList: any;

  ddlSubscriptType: string = null;
  SubscriptTypeList: any;
  txtSubscriptionStartDate: string = null;
  txtSubscriptionEndDate: string = null;

  ddlPerputualType: string = null;
  PerputualTypeList: any;
  // End variable  Project Document Zone
  //ย้ายไป Event Component
  // Variable Lesson Learned Zone
  issueListAll: IssueInfo[]
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;
  baselineListSortbybaselineId: BaselineInfo[];

  IssueSummaryTotal: any

  lblbaselinestartdate: string;
  lblbaselineenddate: string;
  lblbaselinetotaldays: number;
  lblactualstartdate: string;
  lblactualenddate: string;
  lblactualtotaldays: number;
  lbloverduedays: number;
  totalticket: number;
  // End Variable Lesson Learned Zone

  // Variable Event Zone

  // End Variable Event Zone

  _RoleCode: string;

  // Dashboard variable
  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';
  public TabProjectPlanIndex = 1;
  public TabOrganizationalIndex = 1;

  Stagelist: any;
  Actionlist: any;

  // Form Group
  ProjectDetailForm: FormGroup;


  // Form Group for Assign Member
  AssignMemberForm: FormGroup;
  // array control Assign Member
  itemsAssignMemberForm_array: FormArray;
  // array of remove AssignMember
  //itemsRemoveAssignMember_array: ProjectMemberInfo[] = [];
  // Emp List for Assign Member
  EmployeeList: EmpInfo[] = [];
  // Lookup MASTERPROJECTROLE List for Assign Member
  PositionInProjectList: LookupInfo[] = [];

  // Assign Member Lead List
  AssignMemberLeadList: ProjectMemberInfo[] = [];

  // show only Manager
  IsShowForThisUserOtherManager: boolean;

  // Emp Manager current project
  EmpManager: string

  // array control
  itemsSetup: FormArray;
  itemsBaseline: FormArray;

  BaselineList: BaselineInfo[];
  BaselineTimeList: BaselineInfo[];

  // Org Chat
  filesToUpload: File[];
  pathImg: string = '';

  //Base line document
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';

  ListState: StateInfo[] = [];

  async ngOnInit() {


    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");
    this._RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = !!this._ParamProjectCode ? this._ParamProjectCode : this.GetParam('ProjectCode').toString();

    // create control
    this.ProjectDetailForm = await this.formBuilder.group({
      AssignMemberForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemAssignMemberDefault()])
      })
    });


    // set AssignMemberForm from InformationForm
    this.AssignMemberForm = this.ProjectDetailForm.get('AssignMemberForm') as FormGroup

    // get items array to itemsAssignMemberForm_array
    this.itemsAssignMemberForm_array = this.AssignMemberForm.get('items') as FormArray;

    // Load detail
    await this.LoadProjectDetail();
    // Load Assign Member Support
    await this.ReLoadAssignMember();

  }
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
  }

  ///////////////////////////////////////Events////////////////////////////////////////////


  ///////////////////////////////////////Functions/////////////////////////////////////////

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectDocument"]').prop('checked', check);

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  async LoadProjectDetail() {
    var auth_token = await this.TokenService.RefreshToken();
    this.loadDDLStatus(auth_token)
      .subscribe({
        next: data => {
          this.ProjectStatusList = data;
          if (this.ProjectStatusList.length) {
            // Get Project Detail
            this.LoadProjectList(auth_token)
              .subscribe({
                next: data => {
                  this.ProjectList = data;
                  if (this.ProjectList.length) {
                    this.isOnUpdate = true



                    this.ddlProjectStatus = this.ProjectList[0].ProjectStatusCode != null ? this.ProjectList[0].ProjectStatusCode : null
                    this.ddlProjectStatusSavedraft = this.ddlProjectStatus;
                    this.txtProjectCode = this.ProjectList[0].ProjectCode != null ? this.ProjectList[0].ProjectCode : null
                    this.txtProjectName = this.ProjectList[0].ProjectName != null ? this.ProjectList[0].ProjectName : null
                    this.txtProjectStart = this.ProjectList[0].ProjectStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectStart) : null
                    this.txtProjectEnd = this.ProjectList[0].ProjectEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectEnd) : null

                    this.ddlSupportContractType = this.ProjectList[0].ProjectSupportContractTypeCode != null ? this.ProjectList[0].ProjectSupportContractTypeCode : null

                    this.ddlWarrantyType = this.ProjectList[0].ProjectWarrantyTypeCode != null ? this.ProjectList[0].ProjectWarrantyTypeCode : null
                    this.ddlMAType = this.ProjectList[0].ProjectMATypeCode != null ? this.ProjectList[0].ProjectMATypeCode : null
                    this.txtWarrantyStartDate = this.ProjectList[0].ProjectWarrantyStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyStart) : null
                    this.txtWarrantyEndDate = this.ProjectList[0].ProjectWarrantyEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyEnd) : null
                    this.txtMAStartDate = this.ProjectList[0].ProjectMAStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAStart) : null
                    this.txtMAEndDate = this.ProjectList[0].ProjectMAEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAEnd) : null
                    this.ddlPackage = this.ProjectList[0].ProjectPackage != null ? this.ProjectList[0].ProjectPackage : null
                    this.pathImg = this.ProjectList[0].ProjectImgPath != null ? this.ProjectList[0].ProjectImgPath : null
                    this.txtProjectComment = this.ProjectList[0].Comment != null ? this.ProjectList[0].Comment : null
                    this.ddlSubscriptType = this.ProjectList[0].ProjectSubscriptType != null ? this.ProjectList[0].ProjectSubscriptType : null
                    this.txtSubscriptionStartDate = this.ProjectList[0].ProjectSubscriptStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptStart) : null
                    this.txtSubscriptionEndDate = this.ProjectList[0].ProjectSubscriptEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptEnd) : null
                    this.hidProjectId = this.ProjectList[0].ProjectId

                    this.ddlPerputualType = this.ProjectList[0].ProjectPerputualType != null ? this.ProjectList[0].ProjectPerputualType : null

                    if (this.pathImg != null) {
                      $('#previewImg').show();
                    } else {
                      $('#previewImg').hide();

                    }

                    this._ParamProjectName = this.txtProjectName;
                    this._ParamCompanyName = this.ProjectList[0].ProjectCompanyName;

                    // flag display for Manager Only and not Waranty-Completed
                    this.IsShowForThisManager = (this.ProjectList[0].ProjectAssignManagerSupport == this.checkUndefinedString(localStorage.getItem("EmpCode")) && this.ProjectList[0].ProjectStateCode != '3-2')

                  }


                },
                error: error => {
                  console.error('There was an error!', error);
                }
              })

          }


        },
        error: error => {
          console.error('There was an error!', error);
        }
      })






  }


  loadDDLStatus(auth_token): Observable<LookupInfo[]> {
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"PROJECTSTATUS\" }";

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
    }
  }


  



  LoadProjectList(auth_token): Observable<ProjectInfo[]> {
    //var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"ProjectCode\": \"" + this.checkUndefinedString(this._ParamProjectCode) + "\", " +

        "\"rowFetch\": " + environment.PageSize + ", " +
        "\"rowOFFSet\": " + offset + ", " +
        "\"FlagDelete\": \"N\" " +
        "}";

      return this.httpClient
        .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria",
          strjson, httpOptions)
    }

  }
  


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }









  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  ConvertDatetoDatetime(DateValue) {
    if (DateValue) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];
      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daydisplay = day.toString();
      if (day < 10) {
        daydisplay = '0' + day
      }

      var monthIndex = date.getMonth() + 1;
      var monthisplay = monthIndex.toString();
      if (monthIndex < 10) {
        monthisplay = '0' + monthIndex
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = year + "-" + monthisplay + "-" + daydisplay;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }


  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  


  // ----------------------- Function Assign Member Zone -----------------------------------------
  createItemAssignMemberDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [null],
      EmpName: [null, Validators.required],
      EmpNameDisplay: [null],
      PositionInProject: [null],
      PositionInProjectDisplay: [null],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }

  createItemAssignMember(ProjectMemberitem: ProjectMemberInfo): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [ProjectMemberitem.Id],
      EmpName: [ProjectMemberitem.EmpCode, Validators.required],
      EmpNameDisplay: [ProjectMemberitem.EmpNameDisplay],
      PositionInProject: [''],
      PositionInProjectDisplay: [''],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }


  async loadAssignMemberProject() {
    // clear old
    this.itemsAssignMemberForm_array.clear();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = 'Support';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetProjectMember", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emp manager cuurent project (Lookup Project Manager from data on object property LookupCode = 1)
          var listempmanager = data.filter(function (obj) {
            return obj.PositionInProject == '1';
          });

          if (listempmanager.length) {
            this.EmpManager = listempmanager[0].EmpCode;
          }

          // Remove Lookup Project Manager from data on object property LookupCode = 1
          data = data.filter(function (obj) {
            return obj.PositionInProject !== '1';
          });

          this.AssignMemberLeadList = data;

          // if not empty Assign Member set default and Current User is Manager
          if (this.AssignMemberLeadList.length <= 0 && this.IsShowForThisManager == true) {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
          }

        


        });
    }
  }

  async loadEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emplist for assign member without cuurent manager 
          this.EmployeeList = data.filter(obj => {
            return obj.EmpCode !== this.EmpManager;
          });
          // load detail emp for assign member
          this.AssignMemberLeadList.forEach((traget, indextraget) => {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMember(traget));
            //load detail of Emp
            this.onChanges(indextraget)
          });

        });
    }
  }

  addAssignMemberItem(): void {
    this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
  }

  removeAssignMemberItem(indexitem): void {
    // get id cuurent AssignMember
    var cuurentIdAssignMember = this.itemsAssignMemberForm_array.at(indexitem).value.ProjectMemberId;

    if (cuurentIdAssignMember != null) {
      // set FlagRemove Assign Member
      this.itemsAssignMemberForm_array.at(indexitem).value.FlagRemove = true;
    } else {
      // remove from Array
      this.itemsAssignMemberForm_array.removeAt(indexitem);
    }


  }

  // get count remove Assign Member for Display No.
  getcountremove() {
    return this.itemsAssignMemberForm_array.controls.filter(function (obj) {
      return obj.value.FlagRemove === true;
    }).length;
  }

  async onChanges(idx) {

    //this.selectEmpName = empcode;
    var empcode = this.itemsAssignMemberForm_array.controls[idx].get('EmpName').value;

    var position = this.EmployeeList.find(x => { return x.EmpCode == empcode }).PositionName;
    var nickname = this.EmployeeList.find(x => { return x.EmpCode == empcode }).NickName;
    var mobile = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mobile;
    var mails = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mail;
    //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
    //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;

    var EmpPosition = this.itemsAssignMemberForm_array.controls[idx].get('PositionInProjectDisplay');
    var EmpNickname = this.itemsAssignMemberForm_array.controls[idx].get('NickName');
    var EmpPhone = this.itemsAssignMemberForm_array.controls[idx].get('Phone');
    var EmpMail = this.itemsAssignMemberForm_array.controls[idx].get('Email');

    EmpPosition.setValue(position);
    EmpNickname.setValue(nickname)
    EmpPhone.setValue(mobile)
    EmpMail.setValue(mails)
  }

  async ReLoadAssignMember() {
    // set to default
    this.AssignMemberForm.markAsUntouched();

    // ------------------- Assign Member Zone -------------------------------
    // Load Emp List for Assign Member
    await this.loadEmpList();
    //Load PositionInProject (Lookup MASTERPROJECTROLE) for Assgin Member
    await this.GlobalService.loadLookup('MASTERPROJECTROLE').then((data) => {
      // Remove Lookup Project Manager from data on object property LookupCode = 1
      data = data.filter(function (obj) {
        return obj.LookupCode !== '1';
      });

      this.PositionInProjectList = data;
    });

    // Load Assgin Member
    await this.loadAssignMemberProject();
    // ------------------- Assign Member Zone -------------------------------
  }

  async btnClick_submitSaveAssignMember() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.AssignMemberForm.valid) {
        console.log('SaveAssignMember submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listcontrols = this.itemsAssignMemberForm_array.controls;
        var arrayinsert = [];
        listcontrols.forEach((itemcurrent) => {
          var objectjson = {};

          objectjson['Id'] = itemcurrent.value.ProjectMemberId;
          objectjson['ProjectCode'] = this._ParamProjectCode;
          objectjson['ProjectType'] = "Support";
          objectjson['EmpCode'] = itemcurrent.value.EmpName;

          var EmpRole = this.EmployeeList.find(x => { return x.EmpCode == itemcurrent.value.EmpName }).RoleCode;

          objectjson['EmpRole'] = EmpRole;
          objectjson['FlagRemoveAssignMemberFromClient'] = itemcurrent.value.FlagRemove;

          objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          arrayinsert.push(objectjson);
        });

        let strjson = JSON.stringify(arrayinsert);
        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateAssignMemberProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("SaveAssignMember fail")
            this.titlemodal = 'Save Assign Member fail.';
            this.detailmodal = 'Save Assign Member was saved fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("SaveAssignMember = " + this.isSubmitted)
              await this.ReLoadAssignMember();
              this.loading(false);
              this.titlemodal = 'Saving Assign Member done.';
              this.detailmodal = 'Your member was updated successfully.';
              $('#ModalComplate').modal();
            }
          )

      } else {
        this.GlobalService.markFormGroupTouched(this.AssignMemberForm);
      }
    }
  }
  // ----------------------- Function Assign Member Zone -----------------------------------------

}
